import React from 'react'
import './ArtistCard.css'
import axios from 'axios'
const ArtistCard = ({ data }) => {
    console.log(data)

  return (
    <div className='artist_card'>

    </div>
  )
}

export default ArtistCard